import { useDispatch, useSelector } from 'react-redux';
import { ResponsiveDialog } from 'ui';
import { getShowCompanyDetail, setShowCompanyDetail } from '../../../store/userSlice';
import { RegisterModal } from '../login-register/register-modal';

export default function RegisterCompanyDetailsModal() {

    const dispatch = useDispatch()
    // const itemDetails = useSelector(getSelectedSiteCollaborateInfo)
    const showCompanyDetail = useSelector(getShowCompanyDetail)

    const handleChange = (bool: boolean) => {
        dispatch(setShowCompanyDetail({ open: bool, companyName: null }));
    };

    return (
        <ResponsiveDialog open={showCompanyDetail} onOpenChange={handleChange}>
            <RegisterModal />
        </ResponsiveDialog>
    );
}
